import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetchSyarahv2 from "@/common/fetchSyarahv2";

/**
 *
 * @param source
 * @param phone_number
 * @param otp_length
 * @throws validationException
 */
export var api__sendOtp = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var source, phone_number, otp_length, params;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          source = _ref.source, phone_number = _ref.phone_number, otp_length = _ref.otp_length;
          params = {
            phone_number: phone_number,
            otp_length: otp_length
          };
          _context.next = 4;
          return fetchSyarahv2({
            throwValidationException: true
          }).post("/auth/otp-send?source=".concat(source), params);
        case 4:
          return _context.abrupt("return", _context.sent);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function api__sendOtp(_x) {
    return _ref2.apply(this, arguments);
  };
}();